import { request } from '../request';
import queryString from 'query-string'


export interface TraitItem {
    name: string;
    code: string;
    pk: number;
    value_type: string;
    unit: string | null;
    name_with_unit?: string;
    scheduled_visits: Array<{
        id: number;
        name: string;
        order: number;
        parent_id: number | null;
    }>;
}

export function getTrialTraitsForStats(trialId: string, search_term: string = ''): Promise<TraitItem[]> {
    return request(
        'GET',
        `/api/v2/measurement_metas/?${queryString.stringify({ trial_id: trialId, for_statistics: true, search_term: search_term })}`,
        {},
        { injectTenant: true, version: 2 }
    );
}

/**
 * Traits that can drive the observations heatmap: stored integer/decimal traits, plus
 * derived traits whose formula resolves to a number. The server decides eligibility, so
 * callers can render everything returned without inspecting value types.
 */
export function getTrialTraitsForHeatmap(trialId: string, search_term: string = ''): Promise<TraitItem[]> {
    return request(
        'GET',
        `/api/v2/measurement_metas/?${queryString.stringify({ trial_id: trialId, for_heatmap: true, search_term: search_term })}`,
        {},
        { injectTenant: true, version: 2 }
    );
}